@use "@fukuri-admins/ui/layout" as *;

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title {
  margin: 0;
  @include typography('Jp/20_W6');
  color: text('High');
}
